import React from "react"
import "./index.css"
import Nav from "../../components/nav"
import Footer from "../../components/footer"
import Card from "../../components/dashboard-card"
import CardHeader from "../../components/dashboard-card-header"
import Row from "react-bootstrap/Row"
import Container from "react-bootstrap/Container"
import Col from "react-bootstrap/Col"
import orders from "../../assets/order.svg"
import DataTable from "react-data-table-component"
import orderModel from "../../utils/orderModel"
import AddOrderButton from "../../components/add-order-button"
import Helmet from "react-helmet"
import Modal from "../../components/add-order-modal"
import SweetAlert from "../../components/custom-sweetalert"

const PanelView = props =>
  !props.initializing && (
    <div className={"panel"}>
      <Helmet>Orders | {process.env.REACT_APP_NAME}</Helmet>
      <Nav logOut={props.logOut} user={props.user} />
      <Container className={"mt-5 pb-5"}>
        <Row>
          <Col
            md={{
              span: 10,
              offset: 1,
            }}
          >
            <Card className={"card-padding mb-4"}>
              <CardHeader icon={orders}>Orders</CardHeader>
              <div className={"sub-title"}>
                <p>This is a list of all your orders</p>
              </div>
              <div className={"body"}>
                <DataTable
                  columns={orderModel}
                  data={props.orders.map((datum, index) => {
                    datum.index = index + 1
                    return datum
                  })}
                  striped
                  highlightOnHover
                  responsive
                />
                <div className={"button-container"}>
                  <AddOrderButton onClick={props.openModal} />
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
      <Footer />
      <Modal
        show={props.showModal}
        user={props.user}
        onHide={props.closeModal}
        onSubmit={props.submitNewOrder}
        newOrder={props.newOrder}
        onChange={props.onChange}
        formSubmitting={props.formSubmitting}
      />
      {props.alert && <SweetAlert {...props.alert} />}
    </div>
  )

export default PanelView



// WEBPACK FOOTER //
// ./src/routes/panel/PanelView.js